export const RESEARCHER = "RESEARCHER";
export const AGENCY_ADMIN = "AGENCY_ADMIN";
export const CLIENT_ADMIN = "CLIENT_ADMIN";
export const SUPERVISOR = "SUPERVISOR";
export const CB_ADMIN = "CITYBASE_ADMIN";
export const CREATE_CLIENT_ADMIN = "CREATE_CLIENT_ADMIN";
export const PROFILE = "PROFILE";
export const ADD = "ADD";
export const EDIT = "EDIT";
